<nz-layout class="gradients">
  <nz-header [ngClass]="{'scrolled': isScrolled}">
    <div nz-flex nzJustify="space-between">
      <div>
        <div class="sidebar-logo">
          <a routerLink="/">
            <img src="./assets/landing/img/eq_favicon.png" alt="logo">
          </a>
        </div>
      </div>
      <div class="hamburger" (click)="openDropdownMenu()">
        @if (isDropdownMenuOpen) {
          <i nz-icon nzType="close" nzTheme="outline"></i>
        } @else {
          <i nz-icon nzType="menu" nzTheme="outline"></i>
        }
      </div>
      <nav id="navigation" [class.open]="isDropdownMenuOpen">
        <ul nz-menu nzMode="horizontal">
          <li nz-menu-item *ngIf="(isAuthenticated$ | async)">
            <a routerLink="/all-projects" i18n><span nz-icon nzType="build"></span>Проекты</a>
          </li>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async)" nz-popover [nzPopoverContent]="registryMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="database"></span>{{ navigationLocalize.registryLocalize }}
          </li>
          <ng-template #registryMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/registry" i18n>Мой реестр</a></li>
              <li nz-menu-item><a routerLink="/registry/expert-requests" i18n>Заявления экспертов</a></li>
              <li nz-menu-item><a routerLink="/registry/engineer-requests" i18n>Заявления ИТР</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async)" nz-popover [nzPopoverContent]="technicalSupervisionMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="safety-certificate"></span>{{ navigationLocalize.technicalSupervisionLocalize }}
          </li>
          <ng-template #technicalSupervisionMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/forms/technical-supervision-report-start-form" i18n>Новый отчет</a></li>
              <li nz-menu-item><a routerLink="/reports" i18n>Журнал отчетов ТН</a></li>
              <li nz-menu-item><a routerLink="/reports/organizations" i18n>Журнал отчетов компании</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isKhc$ | async)" nz-popover [nzPopoverContent]="khcMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="eye-invisible"></span>КЖК
          </li>
          <ng-template #khcMenu>
            <ul nz-menu>
              <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isKhcAdmin$ | async)"><a routerLink="/khc/new-object" i18n>Создать объект</a></li>
              <li nz-menu-item><a routerLink="/khc/objects" i18n>Объекты</a></li>
              <li nz-menu-item><a routerLink="/khc/monthly-statistics" i18n>Статистика по отчетам</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isGask$ | async)" nz-popover [nzPopoverContent]="gaskMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="eye-invisible"></span>{{ navigationLocalize.GASKLocalize }}
          </li>
          <ng-template #gaskMenu>
            <ul nz-menu>
              <li nz-menu-item nzMatchRouter nzMatchRouterExact>
                <a routerLink="/reports/gask" i18n>Поданные отчеты ТН</a>
              </li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isKds$ | async)" nz-popover [nzPopoverContent]="kdsMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="eye-invisible"></span>КДСиЖКХ
          </li>
          <ng-template #kdsMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/kds/expert-requests" i18n>Статистика</a></li>
              <li nz-menu-item><a routerLink="/kds/expert-requests" i18n>Реестр: Эксперты</a></li>
              <li nz-menu-item><a routerLink="/kds/engineer-requests" i18n>Реестр: ИТР</a></li>
              <li nz-menu-item><a routerLink="/kds/suspicious-experts" i18n>Отчеты ТН не в одном регионе</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isAdmin$ | async)" nz-popover [nzPopoverContent]="adminMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="setting"></span>Админка
          </li>
          <ng-template #adminMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/demo/info" i18n>ВАЖНО!</a></li>
              <li nz-menu-item><a routerLink="/admin/users" i18n>Пользователи</a></li>
              <li nz-menu-item><a routerLink="/admin/roles" i18n>Роли</a></li>
              <li nz-menu-item><a routerLink="/admin/processes" i18n>Процессы</a></li>
              <li nz-menu-item><a routerLink="/admin/projects" i18n>Проекты</a></li>
              <li nz-menu-item><a routerLink="/admin/special-journal-dictionaries" i18n>Справочник специальных журналов</a></li>
              <li nz-menu-item><a routerLink="/admin/architectural-bureau-references" i18n>Справочник АБП</a></li>
              <li nz-menu-item><a routerLink="/admin/executive-act-keys" i18n>Шаблоны исполнительных актов</a></li>
              <li nz-menu-item><a routerLink="/admin/expert-requests" i18n>Реестр: Эксперты</a></li>
              <li nz-menu-item><a routerLink="/admin/engineer-requests" i18n>Реестр: Заявления ИТР</a></li>
              <li nz-menu-item><a routerLink="/admin/engineer-search" i18n>Реестр: аттестаты ИТР</a></li>
              <li nz-menu-item><a routerLink="/admin/registry-persons" i18n>Реестр: Физические лица</a></li>
              <li nz-menu-item><a routerLink="/admin/registry-organizations" i18n>Реестр: Юридические лица</a></li>
              <li nz-menu-item><a routerLink="/admin/all" i18n>Реестр: Прикрепления/Открепления</a></li>
              <li nz-menu-item><a routerLink="/admin/dictionaries/professions" i18n>Справочник "Национальный классификатор занятий"</a></li>
              <li nz-menu-item><a routerLink="/admin/billing-contracts" i18n>Договора</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isSupport$ | async)" nz-popover [nzPopoverContent]="supportMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="eye-invisible"></span>SUPPORT
          </li>
          <ng-template #supportMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/support/person-actualize" i18n>Актуализация ФЛ</a></li>
              <li nz-menu-item><a routerLink="/support/organization-actualize" i18n>Актуализация ЮЛ</a></li>
            </ul>
          </ng-template>

          <li nz-menu-item *ngIf="(isAuthenticated$ | async) && (isDemo$ | async)" nz-popover [nzPopoverContent]="demoMenu" nzPopoverPlacement="bottom">
            <span nz-icon nzType="eye-invisible"></span>DEMO
          </li>
          <ng-template #demoMenu>
            <ul nz-menu>
              <li nz-menu-item><a routerLink="/commissioning/documents" *ngIf="isAdmin$ | async" i18n>АВЭ (ГАСК, АРХ)</a></li>
              <li nz-menu-item><a routerLink="/egkn/orders" i18n>Регистрация АВЭ (НАО)</a></li>
            </ul>
          </ng-template>

          <ul id="info-avatar-mobile" nz-menu nzMode="horizontal" nz-flex nzAlign="center">
            <li nz-menu-item nz-popover [nzPopoverContent]="infoMenu" nzPopoverPlacement="bottom">
              <i nz-icon nzTheme="outline" nzType="question-circle" class="help-icon"></i>
            </li>

            @if (isAuthenticated$ | async) {
              <li nz-menu-item>
                <a routerLink="/tasks" i18n><span nz-icon nzType="profile"></span>Задачи</a>
              </li>

              <li nz-menu-item nz-popover [nzPopoverContent]="profileMenu" nzPopoverPlacement="bottom">
                <nz-avatar [nzText]="getInitials()" [nzIcon]="!account ? 'user' : ''" class="avatar" />
              </li>
            }
          </ul>
        </ul>
      </nav>
      <div id="info-avatar-desktop" nz-flex>
        <ul nz-menu nzMode="horizontal" nz-flex nzJustify="flex-end">
          <li nz-menu-item nz-popover [nzPopoverContent]="infoMenu" nzPopoverPlacement="bottomRight">
            <i nz-icon nzTheme="outline" nzType="question-circle" class="help-icon"></i>
          </li>
          @if (isAuthenticated$ | async) {
            <li nz-menu-item>
              <a routerLink="/tasks" i18n><span nz-icon nzType="profile"></span>Задачи</a>
            </li>

            <li nz-menu-item nz-popover [nzPopoverContent]="profileMenu" nzPopoverPlacement="bottomRight">
              <nz-avatar [nzText]="getInitials()" [nzIcon]="!account ? 'user' : ''" class="avatar" />
            </li>
          }
        </ul>
      </div>
    </div>
  </nz-header>
  <nz-content nz-flex [nzVertical]="true" nzJustify="space-between">
    <main [class.shift-down]="isDropdownMenuOpen">
      <ng-content></ng-content>
    </main>
    <footer nz-flex [nzVertical]="true">
      <div nz-row nzJustify="center" nzAlign="middle">
        <div
          class="footer__text"
          nz-col
          nzXl="10"
          nzLg="10"
          nzMd="18"
          nzSm="24"
          nzXs="24"
        >
          <img alt="" src="assets/landing/img/eq_logo_main.svg" />
          <p class="descript" style="margin-top: 16px;" i18n>Единая цифровая платформа строительства</p>
        </div>
        <div
          nz-col
          nzXl="10"
          nzLg="12"
          nzMd="18"
          nzSm="24"
          nzXs="24"
          style="padding: 0"
        >
          <nav class="footer-menu">
            <a class="footer-menu__item" [routerLink]="['/about']" fragment="solutions" i18n>Решения</a>
            <a class="footer-menu__item" href="https://reestr.equrylys.kz" target="_blank" i18n>Реестр</a>
            <a class="footer-menu__item" [routerLink]="['/about']" fragment="partners" i18n>Партнеры</a>
            <a class="footer-menu__item" [routerLink]="['/about']" fragment="faq">FAQ</a>
            <a class="footer-menu__item" [routerLink]="['/contacts']" i18n>Контакты</a>
          </nav>
        </div>
      </div>
      <div nz-row nzJustify="center" nzAlign="middle" style="margin-top: 16px">
        <div
          class="copywrite"
          nz-col
          nzXl="10"
          nzLg="12"
          nzMd="18"
          nzSm="24"
          nzXs="24"
        >
          <p class="descript" i18n>©2025 eQurylys.kz. Все права защищены.</p>
        </div>
        <div
          nz-col
          nzXl="10"
          nzLg="10"
          nzMd="18"
          nzSm="24"
          nzXs="24"
          style="padding: 0"
        >
          <nav class="footer-menu">
            <a
              routerLink="/privacy-policy"
              ariaCurrentWhenActive="page"
              class="footer-alternate"
              i18n
            >Политика конфиденциальности</a
            >
          </nav>
        </div>
      </div>
    </footer>
  </nz-content>
</nz-layout>

<ng-template #infoMenu>
  <ul nz-menu class="call-center">
    <li nz-menu-item class="not-clickable">Call Center: <a href="tel:+77003018332"> +7 (700) 301-83-32</a></li>
    <li nz-menu-item class="not-clickable" style="margin-top: -12px" i18n>Почта: <a href="mailto:hello@equrylys.kz"> hello&#64;equrylys.kz </a></li>
  </ul>
  <div nz-menu-divider></div>
  <ul nz-menu>
    <li nz-menu-item><a routerLink="/about" i18n>О системе</a></li>
    <li nz-menu-item><a routerLink="/help" i18n>Помощь</a></li>
    <li nz-menu-item><a routerLink="/contacts" i18n>Контакты</a></li>
  </ul>
</ng-template>
<ng-template #profileMenu>
  @if ((isAuthenticated$ | async) && account) {
    <nz-card style="width:300px;" [nzActions]="[actionLogout]" nzSize="small" [nzBordered]="false">
      <nz-card-meta
        [nzTitle]="profileTitle"
        nzDescription="{{ account && account.organization ? account!.organization : '' }}"
      ></nz-card-meta>
      <div nz-row [nzGutter]="0" nzJustify="space-around" nzAlign="middle" style="margin-top: 15px">
        <div nz-col nzFlex>
          <nz-radio-group [(ngModel)]="activeLocale" (ngModelChange)="changeLocale()" nzButtonStyle="solid">
            <label nz-radio-button nzValue="kk">ҚАЗ</label>
            <label nz-radio-button nzValue="ru">РУС</label>
          </nz-radio-group>
        </div>
      </div>
    </nz-card>
    <ng-template #profileTitle>
      <h4><a routerLink="/profile" nz-tooltip [nzTooltipTitle]="navigationLocalize.goToProfileLocalize">{{ getFullName() || 'Профиль' }}</a></h4>
    </ng-template>
    <ng-template #actionLogout>
      <a nz-button nzBlock nzShape="round" nzType="primary" nzDanger routerLink="/logout" i18n>Выйти</a>
    </ng-template>
  }
</ng-template>
